export default "__VITE_ASSET__b5690e46__"